// the semi-colon before function invocation is a safety net against concatenated
// scripts and/or other plugins which may not be closed properly.
;
(function($, window, document, undefined) {
    const { setLoanTerm } = require('../terms');
    "use strict";

    function debounce(func, wait, immediate) {
        var debouncerTimeout;
        return function() {
            var context = this,
                args = arguments;
            var later = function() {
                debouncerTimeout = null;
                if (!immediate) func.apply(context, args);
            };
            var callNow = immediate && !debouncerTimeout;
            clearTimeout(debouncerTimeout);
            debouncerTimeout = setTimeout(later, wait);
            if (callNow) func.apply(context, args);
        };
    }

    // Create the defaults once
    var pluginName = "picker",
        defaults = {
            headerText: 'Please pick below',
            classes: '',
            deferChange: false
        };

    // The actual plugin constructor
    function Plugin(element, options) {
        options = options || {};
        this.element = element;
        this.$element = $(element);
        this.settings = $.extend({}, defaults, options);
        this.getSettingsFromData();
        this._defaults = defaults;
        this._name = pluginName;
        if (options.noInit !== true) {
            this.init();
        }
    }

    // Avoid Plugin.prototype conflicts
    $.extend(Plugin.prototype, {
        getSourceClickHandler: function() {
            var select = this.select;
            var plugin = this;
            return function(e){
                plugin.modal.modal('show');
            };
        },
        getPickerValue: function(){
            var select = this.select;
            var plugin = this;
            var scroller = this.pickerScroller;
            var scrollTop = scroller[0].scrollTop;
            var index = Math.round(scrollTop / 60);
            var options = scroller.find('li[data-value]');
            var value = $(options.get(index)).data('value');
            return value;
        },
        getScrollHandler: function() {
            var select = this.select;
            var plugin = this;
            return function(e) {
                var scroller = $(e.currentTarget);
                var value = plugin.getPickerValue();
                if (!plugin.settings.deferChange) {
                    methods.updateOriginalValue(plugin, value);
                } else {
                    select.attr('data-picker-deferred-value', value);
                }

                var optionList = scroller.find('li');
                var option = optionList.filter('[data-value="' + value + '"]');
                if ($('body').is('.main-home')) {
                    setLoanTerm(value);
                }
                try {
                    var newScrollTop = option[0].offsetTop - 120;
                    scroller.animate({ scrollTop: newScrollTop }, 50);
                } catch (e) { }
            };
        },
        buildModal: function() {
            var plugin = this;
            var modal = '<div class="modal fade {{ modalClasses }}">';
            modal += '<div class="modal-dialog">';
            modal += '<div class="modal-content">';
            modal += '<div class="modal-header">';
            modal += '<span class="header">{{ header }}</span>';
            modal += '</div>';
            modal += '<div class="modal-body">';
            modal += '<div class="row">';
            modal += '<div class="col-xs-12 text-center">';
            modal += '<a href="#" class="btn btn-green form_address_picker_modal_button" data-dismiss="modal">OK</a>';
            modal += '</div>';
            modal += '</div>';
            modal += '</div>';
            modal += '</div>';
            modal += '</div>';
            modal += '</div>';
            modal = modal.replace('{{ header }}', this.settings.headerText);
            modal = modal.replace('{{ modalClasses }}', this.settings.classes);
            this.modal = $(modal);
            if (this.settings.deferChange == true) {
                this.modal.on('hide.bs.modal', function(event){
                    methods.updateOriginalValue(plugin, plugin.$element.data('pickerDeferredValue'));
                    plugin.element.removeAttr('data-picker-deferred-value');
                });
            }
            this.modal.on('show.bs.modal', function(event){
                // Set the opacity of the
                plugin.modal.find('.modal-content').css('opacity', 0);
            });
            this.modal.on('shown.bs.modal', function(event){
                // Set the opacity of the
                methods.setValue(plugin, plugin.$element.val());
                if ($.velocity) {
                    plugin.modal.find('.modal-content').velocity({'opacity': 1}, {duration: 250});
                } else {
                    plugin.modal.find('.modal-content').css({'opacity': 1});
                }
            });
            this.select.after(this.modal);
        },
        create: function() {
            var select = $(this.element);
            this.select = select;
            this.selectPickerWrapper = $('<div class="select-picker-wrapper"></div>');
            this.clickTarget = $('<div class="picker-click-target"></div>');
            this.select.before(this.selectPickerWrapper);
            this.selectPickerWrapper.prepend(this.clickTarget);
            this.select.prependTo(this.selectPickerWrapper);
            this.buildModal();
            this.picker = $('<div class="digi-picker-wrapper"></div>');
            this.pickerScroller = $('<div class="digi-picker-scroller"></div>');
            this.reticule = $('<div class="digi-picker-reticule"></div>');
            this.rail = $('<ul class="digi-picker-rail"></ul>');
            this.picker.append(this.reticule);
            this.pickerScroller.append(this.rail);
            this.picker.append(this.pickerScroller);
            var options = select.find('option').not('[disabled=disabled]');
            this.rail.append($('<li class="dummy"></li>'));
            this.rail.append($('<li class="dummy"></li>'));
            var rail = this.rail;
            var $o2;
            options.each(function(i2, o2) {
                $o2 = $(o2);
                rail.append($('<li data-value="' + $o2.val() + '"></li>').text($o2.text()));
            });
            this.rail.append($('<li class="dummy"></li>'));
            this.rail.append($('<li class="dummy"></li>'));
            select.after(this.picker);
            this.modal.find('.modal-body').prepend(this.picker);
            this.picker.height('300px');
            methods.setValue(this, select.val(), 0);
            // Set click handler to open the modal
            this.clickTarget.click(this.getSourceClickHandler());
        },
        init: function() {
            var select = $(this.element);
            var wrapper = select.closest('.select-picker-wrapper');
            if (wrapper.length !== 1) {
                this.create();
                // Set the initial selected value
                var origValue = select.val();
                methods.setValue(this, origValue);
                this.pickerScroller.scroll(debounce(this.getScrollHandler(), 150, false));
            } else {
                this.picker = wrapper.find('.digi-picker-wrapper');
                this.pickerScroller = this.picker.find('.digi-picker-scroller');
                this.reticule = this.picker.find('.digi-picker-reticule');
                this.rail = this.picker.find('.digi-picker-rail');
            }
        },
        getSettingsFromData: function() {
            var dataMap = {
                'pickerHeaderText': 'headerText',
                'pickerClasses': 'classes',
                'pickerDeferChange': 'deferChange'
            };
            var data = this.element.data();
            for (var k in data) {
                if (typeof dataMap[k] !== 'undefined') {
                    this.settings[dataMap[k]] = data[k];
                }
            }
        }
    });

    var methods = {
        isInitialized: function($this){
            return $this.element.closest('.select-picker-wrapper').length > 0;
        },
        destroy: function($this) {
            var wrapper = $this.element.closest('.select-picker-wrapper');
            if (wrapper.length === 1) {
                $this.element.insertBefore(wrapper);
                wrapper.remove();
            }
        },
        updateOriginalValue: function($this, value) {
            $($this.element).val(value).change();
        },
        getScrollPositionForValue: function($this, value) {
            var options = $this.element.find('option');
            if (value != null && value !== '') {
                value = value.toString().replace(/([ #;&,.+*~\':"!^$[\]()=>|\/@])/g,'\\$1');
            }
            var option = options.filter("[value='" + value + "']");
            var index = options.index(option);
            var scrollPosition = index * 60;
            return scrollPosition;
        },
        setValue: function($this, value, animationDuration) {
            animationDuration = animationDuration || 50;
            var scrollPosition = this.getScrollPositionForValue($this, value);
            if(animationDuration === 0) {
                $this.pickerScroller.css({ scrollTop: scrollPosition });
            } else {
                $this.pickerScroller.animate({ scrollTop: scrollPosition }, animationDuration);
            }
        },
        getValue: function($this) {
            return $this.element.val();
        }
    };

    // A really lightweight plugin wrapper around the constructor,
    // preventing against multiple instantiations
    $.fn[pluginName] = function(options) {
        if (this.length !== 1) {
            this.each(function(i,o){
                $(o).picker(options);
            });
        } else {
            if(window.innerWidth > 991 && !$('body').hasClass('carLoan')){
                return false;
            }
            if (methods[options]) {
                var plugin = new Plugin(this, { noInit: true });
                return methods[options].apply(methods, [plugin].concat(Array.prototype.slice.call(arguments, 1)));
            } else if (typeof options === 'object' || !options) {
                // Default to "init"
                return new Plugin(this, options);
            } else {
                $.error('Method ' + options + ' does not exist on jQuery.tooltip');
            }
        }
    };

})(jQuery, window, document);